export default __webpack_public_path__ + "static/media/restaurationen-alternative.c92ddd9e.png";